import { UNATTACHED_TRIGGERS, type WorkflowTrigger } from "@sagot/constants";
import type { Problem } from "./problem-model";
import type { Definition } from "./types";

/**
 * The rule of the backend's `graph_content.py`: an AI summary reads the conversation, so a trigger that starts before one
 * exists (the widget opening, a Home option, a page visit, a click) cannot use it. (The triggers that never have one - lead,
 * booking and source events - are the generic `needs_conversation` of `actionProblems`, and an article on a trigger with no
 * visitor is the generic `not_facing` of `facingProblems`.)
 */
export function contentProblems(definition: Definition, trigger: WorkflowTrigger): Problem[] {
  if (!UNATTACHED_TRIGGERS.has(trigger)) return [];
  return Object.entries(definition.paths).flatMap(([path, body]) =>
    body.steps.flatMap((step) => (step.type === "add_summary_note" ? [{ code: "no_summary_here", where: `step ${step.id}`, path, stepId: step.id, params: {}, source: "client" as const }] : [])),
  );
}
